import { Typography } from "@sidelinesports/fan-design-system";
import type { ApiGameDetails } from "../../../../api";
import styles from "./ScoreLegendTable.module.css";

export const ScoreLegendTable = ({ game }: { game: ApiGameDetails }) => {
  return (
    <table className={styles.table}>
      <tbody>
        {game.availableEvents.map((event) => (
          <tr key={event.id}>
            <th scope="row">
              <Typography size="sm">{event.description}</Typography>
            </th>
            <td>
              <Typography size="sm">{event.points}</Typography>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
